export default __webpack_public_path__ + "static/sentrydefault_1920x1080-c537870d0659e24b38d7283b31c5cbb0.webp";